var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoadingData)?_c('Loader',{attrs:{"fullPage":"","useOverlay":"","loader":"spinner"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }